module.exports = "/_next/static/images/constructionManagement-6cbb503a5cfa969aa25d9e329b86f66f.webp";